export const woundTypeKeyForAttribute = {
  bruiseType: "bruise",
  pressureUlcerUnstageableCause: "pressureUlcer",
  pressureKennedyUnstageableCause: "pressureKennedy",
  pressureDeviceRelatedUnstageableCause: "pressureDeviceRelated",
  surgicalOther: "surgical",
  surgicalClosure: "surgical"
};
